var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v("Api Keys")]),
      _vm.keys.length == 0
        ? _c("w-card-actions", { staticClass: "no-keys" }, [
            _vm._v(" Geen keys beschikbaar "),
          ])
        : _vm._e(),
      _c(
        "w-list",
        [
          _vm._l(_vm.keys, function (key) {
            return _c(
              "w-list-item",
              { key: key.id },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(key.name))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.deleteKey(key)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.openApiKeyModal()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(" Nieuwe key aanmaken ")]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.createApiKeyModal } },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v("Nieuwe api key maken")]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { label: "Api key naam" },
                            model: {
                              value: _vm.newApiKeyName,
                              callback: function ($$v) {
                                _vm.newApiKeyName = $$v
                              },
                              expression: "newApiKeyName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "danger",
                      on: {
                        click: function ($event) {
                          _vm.createApiKeyModal = false
                        },
                      },
                    },
                    [_vm._v("Annuleren")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.createApiKey()
                        },
                      },
                    },
                    [_vm._v("Opslaan")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.createdApiKey != "" } },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c("w-card-title", [_vm._v("Api key aangemaakt")]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { xs: "12" } }, [
                        _vm._v(
                          " Nieuwe api key aangemaakt. Koppieer en slaag deze sleutel veilig op. Je kan die nadien NIET meer opvragen. "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-margin": "" } },
                            [
                              _c("w-input", {
                                ref: "createdApiKeyRef",
                                staticClass: "grow",
                                attrs: { value: _vm.createdApiKey },
                                on: {
                                  input: function ($event) {
                                    return _vm.onCreatedApiKeyInput($event)
                                  },
                                },
                              }),
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Api Key koppieren",
                                      expression: "'Api Key koppieren'",
                                    },
                                  ],
                                  attrs: { flat: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copyCreatedApiKeyToClipboard()
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "copy" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.closeCreatedApiKey()
                        },
                      },
                    },
                    [_vm._v("Sluiten")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }